import type {
  Data, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { TermTypeRefCodeCreateMutationVariables } from '@/graphql/generated/graphql';

const termTypeMutations: UpdatesConfig['Mutation'] = {
  termTypeRefCodeCreate: (_: Data, vars: TermTypeRefCodeCreateMutationVariables, cache: Cache) => {
    invalidateQuery('termTypeRefCodes', cache, { input: { product: vars.input.product, ref_code_id: vars.input.ref_code_id } });
  },
};

export default termTypeMutations;
